<template>
    <div>
        <template v-if="item.payment.payer_type === 'App\\Models\\Customer'">
            {{ _.get(item, 'payment.payer.name') }} {{ _.get(item, 'payment.payer.surname', 'Client necunoscut') }} (client)
        </template>
        <template v-else-if="item.payment.payer_type === 'App\\Models\\Account'">
            {{ _.get(item, 'payment.payer.name', `Cont necunoscut ${item.payment.payer_id}`) }} (cont)
        </template>
        <template v-else-if="!_.isNil(item.account_id)">
            {{ _.get(Static.accounts.find(account => account.id === item.account_id), 'name', 'Nedefinit') }} (cont)
        </template>
        <template v-else>
            <b class="text--danger">NECUNOSCUT</b>
        </template>
        <template v-if="item.payment.accountable">
            <br/>
            Conform:
            <template v-if="item.payment.accountable_type === 'App\\Models\\Contract'">
                Contract nr. {{ _.get(item, 'payment.accountable.id', '?') }}/{{ _.get(item, 'payment.accountable.contract_date') }}<br/>
                (referinta document: {{ _.get(item, 'payment.accountable_id')}})
            </template>
            <template v-else>
                <b class="text--danger">NECUNOSCUT</b>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
